import "leaflet/dist/leaflet.css";
import "react-phone-input-2/lib/style.css";
import "react-quill-new/dist/quill.snow.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-loading-skeleton/dist/skeleton.css';
import "react-datepicker/dist/react-datepicker.css";
import "./_CORE/APP/Templates/_Styles/_AppStylesImported.css";
import "./Web/_UI/_Styles/NotebookShellTheme.css";
import "./Web/_UI/_Styles/NotebookWorkspaceTheme.css";
import "./Web/_UI/_Styles/NotebookMonochromeDark.css";

import { AppErrorBoundary } from "./_CORE/APP/Hooks/Contexts/_Auth/_App/_index";
import { AppRouting } from "./_CORE/APP/Routing/AppRouting";
import { AppProviders } from "./_CORE/APP/Hooks/Contexts/_AppProviders";
import { AppTemplateResolved } from "./_CORE/APP/Templates/AppTemplateResolved";
import { APP_ENVIRONMENT } from './_CORE/_Config/_ENV/AppEnvironment';
import { AppConfirmHost } from "./_CORE/APP/Templates/_UI/Confirm/AppConfirmHost";
import { GlobalNotebookSearch } from "./Web/Views/Private/_Center/_UI/GlobalNotebookSearch";

function App() {

    return (
        <AppErrorBoundary isDetailed={APP_ENVIRONMENT.APP__IS_NODE_ENV}>
            <AppTemplateResolved>
                <AppProviders>
                    <AppRouting />
                    <GlobalNotebookSearch />
                    <AppConfirmHost />
                </AppProviders>
            </AppTemplateResolved>
        </AppErrorBoundary>
    );
}

export default App;
